// src/pages/ReservationDetailPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Breadcrumbs, Typography, Link as MUILink } from '@mui/material';
import { Link } from 'react-router-dom';
import BookingDetailView from '../components/BookingDetailView';

export default function ReservationDetailPage() {
  const { referenceNumber } = useParams();
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/bookings/reference/${referenceNumber}`)
      .then(res => res.json())
      .then(data => setBooking(data.booking));
  }, [referenceNumber]);

  const getBookingTotal = (booking) => {
    return booking?.rooms?.reduce((total, room) => total + (room.totalAfterTax || 0), 0).toFixed(2) + ' USD';
  };

  if (!booking) return <div>Loading...</div>;

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" sx={{ px: 4, pt: 2 }}>
        <MUILink component={Link} underline="hover" color="inherit" to="/reservation">
          Reservation Center
        </MUILink>
        <Typography color="text.primary">Reservation Detail</Typography>
      </Breadcrumbs>
      <BookingDetailView booking={booking} getBookingTotal={getBookingTotal} />
    </>
  );
}